'use client';

import dynamic from 'next/dynamic';

export const PricingSectionContent = dynamic(
  () => import('./PricingSectionContent')
);
